'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isBrowser() {
    var _window;
    return typeof window !== 'undefined' && ((_window = window) === null || _window === void 0 ? void 0 : _window.document) != null;
}
exports.isBrowser = isBrowser;
